export default "__VITE_ASSET__1ddfe77d__"